import { type RefObject } from 'react';

export function releaseMicOnceOnSessionOver({
  isSessionOver,
  hasStoppedListeningRef,
  stopListening,
}: {
  isSessionOver: boolean;
  hasStoppedListeningRef: RefObject<boolean>;
  stopListening: (reset?: boolean) => Promise<void>;
}): void {
  if (isSessionOver && !hasStoppedListeningRef.current) {
    hasStoppedListeningRef.current = true;
    stopListening(true).catch(() => undefined);
  }
}

export function snapshotConversationOverText({
  isConversationOver,
  conversationOverRef,
  setConversationOverText,
}: {
  isConversationOver: boolean;
  conversationOverRef: RefObject<string | null>;
  setConversationOverText: (value: string | null) => void;
}): void {
  if (isConversationOver && conversationOverRef.current) {
    setConversationOverText(conversationOverRef.current);
  }
}
